<template>
  <el-container class="notifications">
    <el-container class="main-container">
      <el-main class="main-content">
        <div class="content-header">
          <img
            src="@assets/codeScan/md-notifications_active.png"
            alt="Settings Icon"
            class="settings-icon"
          />
          <h2>{{ $t('notifications.title') }}</h2>
          <div class="action-buttons">
            <el-button
              type="primary"
              :disabled="selectedProjects.length === 0"
              @click="handleDeleteSelected"
              size="mini"
            >{{ $t('notifications.deleteButton') }}</el-button>
            <el-button
              :disabled="selectedProjects.length === 0"
              @click="batchMarkRead"
              size="mini"
              type="primary"
            >{{ $t('notifications.readButton') }}</el-button>
          </div>
        </div>
        <!-- <div class="filter-container">
          <img
            src="@assets/codeScan/notification-icon-filter.png"
            alt="Filter Icon"
            class="filter-icon"
          />
          <el-select
            ref="filterSelect"
            @change="handleFilterChange"
            v-model="selectedFilters"
            clearable
            multiple
            :placeholder="$t('notifications.filter')"
            size="mini"
            class="filter-select"
          >
            <el-option
              :label="$t('notifications.projectName')"
              value="notificationName"
            ></el-option>
            <el-option
              :label="$t('notifications.createBefore')"
              value="receivedBefore"
            ></el-option>
            <el-option
              :label="$t('notifications.scanStatus')"
              value="Mark"
            ></el-option>
          </el-select>
          <el-date-picker
            v-if="showDatePicker"
            v-model="selectedDate"
            type="date"
            size="mini"
            :placeholder="$t('notifications.selectDate')"
            value-format="MM-dd-yyyy"
            @change="handleDateChange"
            ref="hiddenDatePicker"
            class="centered-date-picker"
            style="display: none;"
          ></el-date-picker>
        </div> -->

        <el-table
          :data="projects"
          ref="table"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @expand-change="handleExpandChange"
          :cell-class-name="getCellClassName"
          :row-class-name="tableRowClassName"
          row-key="notificationId"
          :empty-text="$t('notifications.noData')"
          v-loading="loading"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-card class="box-card">
                <div
                  slot="header"
                  class="cardTitle"
                >
                  <span class="cardTitleText">{{ $t('notifications.notificationName') }}: {{ props.row.title }}</span>
                  <span>{{ $t('notifications.receivedTime') }}: {{ dateFormat(props.row.receivedAt) }}</span>
                  <span>{{ $t('notifications.sender') }}: {{ props.row.senderName }}</span>
                </div>
                <div>
                  <p>{{ props.row.content }}</p>
                </div>
              </el-card>
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            :label="$t('notifications.notificationName')"
          >
            <template slot-scope="scope">
              <span :class="{unread: !scope.row.read}">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="receivedAt"
            :label="$t('notifications.receivedTime')"
          >
            <template slot-scope="scope">
              {{ dateFormat(scope.row.receivedAt) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="senderName"
            :label="$t('notifications.sender')"
          >
          </el-table-column>
          <el-table-column
            prop="mark"
            :label="$t('notifications.mark')"
          >
            <template slot-scope="scope">
              <div @click="handleMark(scope.row)">
                <img
                  v-if="scope.row.mark"
                  class="bookmark"
                  src="@assets/codeScan/st-bookmark.png"
                  alt=""
                />
                <img
                  v-else
                  class="bookmark"
                  src="@assets/codeScan/st-bookmark-block.png"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('notifications.delete')">
            <template slot-scope="scope">
              <img
                class="bookmark"
                src="@assets/codeScan/notification-icon-del.png"
                alt=""
                style="cursor: pointer"
                @click="handleDelete(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-footer
          style="height:auto"
          v-if="filteredProjects.length > 0"
        >
          <el-pagination
            :current-page="queryForm.pageNo"
            :layout="layout"
            :pager-count="5"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </el-footer>
      </el-main>
    </el-container>
    <el-dialog
      :visible.sync="deleteVisible"
      width="500px"
      :title="$t('notifications.deleteTask')"
    >
      <div style="text-align: center; font-size: 18px">{{ $t('notifications.deleteConfirmation') }} <span style="font-weight: bold;">{{deleteTaskName}}</span> ?</div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="deleteVisible = false">{{ $t('notifications.cancel') }}</el-button>
        <el-button
          type="primary"
          @click="confirmDelete"
          :loading="deleteLoading"
        >{{ $t('notifications.confirm') }}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { getNotifications, deleteNotifications, markNotification } from '@/api/base';
import { dateLocaleFormat } from '@/lib/date-format';
import { mapGetters } from 'vuex';

export default {
  name: 'NotificationsIndex',
  data() {
    return {
      selectedFilters: [],
      selectedDate: null,
      showDatePicker: false,
      layout: 'prev, pager, next, jumper',
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
      },
      currentPage: 1,
      filter: '',
      selectedProjects: [],
      projects: [],
      loading: false,
      deleteVisible: false,
      deleteTaskName: '',
      deleteIds: [],
      deleteLoading: false,
    };
  },
  computed: {
    ...mapGetters('common', ['locale']),
    filteredProjects() {
      return [];
    },
  },
  methods: {
    handleExpandChange(_row, expandedRows) {
      const expandedRow = expandedRows.find((row) => row.notificationId === _row.notificationId);

      if (!expandedRow) {
        return;
      }

      const ids = expandedRows.map((row) => row.notificationId);

      markNotification({ notificationIds: ids, read: true }).then(() => {
        this.getNotificationList(false);
      });
    },
    batchMarkRead() {
      const ids = this.selectedProjects.filter((item) => !item.read).map((project) => project.notificationId);

      if (ids.length === 0) {
        this.$message({
          type: 'info',
          message: this.$t('notifications.noUnreadNotifications'),
        });

        return;
      }

      markNotification({ notificationIds: ids, read: true }).then(() => {
        this.getNotificationList();
        this.$refs.table.clearSelection();
      });
    },
    handleMark(row) {
      markNotification({ notificationIds: [row.notificationId], mark: !row.mark }).then(() => {
        this.getNotificationList();
      });
    },
    dateFormat(date) {
      return dateLocaleFormat(date, this.locale);
    },
    getNotificationList(loading = true) {
      this.loading = loading;
      const params = {
        page: this.queryForm.pageNo - 1,
        size: this.queryForm.pageSize,
      };

      return getNotifications(params)
        .then((res) => {
          this.projects = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFilterChange(value) {
      const index = value.indexOf('createBefore');
      if (index !== -1) {
        this.filterIndex = index;
        this.selectedFilters = this.selectedFilters.filter((item) => item !== 'createBefore');
        this.showDatePicker = true; // 显示日期选择器
        this.$nextTick(() => {
          this.$refs.filterSelect.blur(); // 手动关闭下拉框
          if (this.$refs.hiddenDatePicker) {
            this.$refs.hiddenDatePicker.showPicker(); // 手动触发日期选择器
          } else {
            console.error('Cannot find hiddenDatePicker ref');
          }
        });
      }
    },
    handleDateChange(date) {
      this.selectedDate = date;
      this.showDatePicker = false;
      // 检查是否已经存在日期
      const createBeforeIndex = this.selectedFilters.findIndex((item) => !isNaN(Date.parse(item)));
      if (createBeforeIndex !== -1) {
        // 覆盖之前的日期选择
        this.selectedFilters.splice(createBeforeIndex, 1, this.selectedDate);
      } else {
        // 添加新的日期选择
        this.selectedFilters.push(this.selectedDate);
      }
      // 在这里你可以处理用户选择的日期
      console.log('Selected date is: ' + this.selectedDate);
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;

      this.getNotificationList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;

      this.getNotificationList();
    },
    handleSelectionChange(val) {
      this.selectedProjects = val;
    },
    handleDeleteSelected() {
      const ids = this.selectedProjects.map((project) => project.notificationId);

      this.deleteTaskName = this.selectedProjects.map((project) => project.title).join(', ');
      this.deleteIds = ids;
      this.deleteVisible = true;
    },
    handleMarkReadSelected() {
      if (this.selectedProjects.length > 0) {
        this.selectedProjects.forEach((project) => {
          project.Mark = '2'; // 标记为已读
        });
      } else {
        this.$message({
          type: 'error',
          message: this.$t('notifications.selectNotificationsFirst'),
          duration: 2000,
        });
      }
    },
    tableRowClassName({ row }) {
      if (this.selectedProjects.includes(row)) {
        return 'selected-row';
      }
      return '';
    },
    getCellClassName({ column, rowIndex }) {
      if (column.property === 'notificationName' && (rowIndex === 2 || rowIndex === 4)) {
        return 'warning-row';
      }
      return '';
    },
    confirmDelete() {
      this.deleteLoading = true;
      const ids = this.deleteIds;
      deleteNotifications({ notificationIds: ids })
        .then(() => {
          this.getNotificationList();
          this.$refs.table.clearSelection();
        })
        .finally(() => {
          this.deleteVisible = false;
          this.deleteLoading = false;
        });
    },
    handleDelete(row) {
      this.deleteVisible = true;
      this.deleteTaskName = row.title;
      this.deleteIds = [row.notificationId];
    },
  },
  mounted() {
    this.getNotificationList();
  },
};
</script>

<style lang="scss">
.notifications {
  width: 100%;
  display: flex;
  background-color: #f5f5f5;
  border-radius: 10px;

  .unread {
    color: #f25248;
  }

  .cardTitle {
    display: flex;
    align-items: center;
    gap: 10px;

    & > .cardTitleText {
      font-weight: 600;
      margin-right: auto;
    }
  }

  .main-container {
    display: flex;
    flex-direction: column;
  }

  .sidebar {
    height: calc(100vh - 85px);
    margin: 50px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
    height: 60px !important;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .logo {
      width: 180px;
    }
  }

  .main-content {
    flex: 1;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 10px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .content {
    flex: 1;
    background-color: #fafafa;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 70px;
    left: 90px;
    width: 95.2%;
    height: calc(100vh - 95px);
  }

  .content-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background-color: #e1e8ed;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;
    line-height: 54px;

    h2 {
      margin: 0;
      padding-top: 5px;
      font-size: 20px;
      font-weight: 600;
    }

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }

  .filter-container {
    display: flex;
    align-items: center;
    margin: 0px 20px;
  }

  .filter-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .filter-select {
    flex: 1;
    margin-right: 10px;
  }

  .notifications-main {
    background: #fff;
    border-radius: 10px;
    margin: 20px -10px;
    overflow: hidden;
  }

  .el-table th.el-table__cell {
    background-color: #eeeeee;
  }

  .el-table__row:hover {
    color: #333;
    border-radius: 10px;
  }

  .el-footer {
    display: flex;
    justify-content: right;
    margin-top: 18px;
  }

  .warning-row {
    color: #f25248 !important;
  }

  .bookmark {
    cursor: pointer;
    width: 30px;
    height: 30px;
  }

  .action-buttons {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
  }
}
</style>
